import React from "react"
import { useTranslation } from "react-i18next"

import { Action } from "shared/types/Action"

import { ProjectPageSidebarActions } from "pages/project-page/ui/ProjectPageSidebarActions"

import "../../../styles/_project-page-sidebar.scss"

export interface ProjectChildMultiSelectSidebarViewModel {
  selectedChildCount: number

  actions: Action[]
  hideControls?: boolean
}

export const ProjectChildMultiSelectSidebarView = React.memo(
  ({
    selectedChildCount,
    actions,
    hideControls
  }: ProjectChildMultiSelectSidebarViewModel) => {
    const { t } = useTranslation()

    return (
      <div
        className="project-page-sidebar project-page-sidebar--project-child-multi-select"
        data-testid="project-sidebar"
      >
        <div className="project-page-sidebar__content">
          <div className="project-page-sidebar__title" aria-live="polite">
            {selectedChildCount} {t("Project.SelectedProjectChildren")}
          </div>
        </div>
        {hideControls ? null : <ProjectPageSidebarActions actions={actions} />}
      </div>
    )
  }
)
